// created enums to manage all routes through single file
export enum AppRoutes {
  Home = '/',
  Login = '/login',
  ActivateAccount = '/activate-account',
  Products = '/products',
  Components = '/components',
  ComponentDetailsTab = '/components/:componentId/component-details',
  ComponentPcfTab = '/components/:componentId/pcf',
  NotFound = '/404',
  ForgotPassword = '/forgot-password',
  ResetPassword = '/reset-password',
  PrivacyPolicy = '/privacy-policy',
  TermsOfUse = '/terms-of-use',
  UserManagement = '/user-management',
  ProductDetailsTab = '/products/:productId/product-details',
  ProductPcfTab = '/products/:productId/pcf',
  ProductPermissionTab = '/products/:productId/permissions',
  ProductFootprintDetails = '/products/:productId/pcf/footprint/:footprintId',
  ProductFootprintDetailsCopy = '/products/:productId/pcf/footprint/:footprintId/copy',
  ComponentFootprintDetails = '/components/:componentId/pcf/footprint/:footprintId',
  ProductFootPrintCalculations = '/products/:productId/pcf/footprint/:footprintId/calculations',
  ProductFootPrintCalculationDetails = '/products/:productId/pcf/footprint/:footprintId/calculations/:calculationId',
  ProductFootPrintCalculationDetailsCopy = '/products/:productId/pcf/footprint/:footprintId/calculations/:calculationId/copy',
  ProductTasksTab = '/tasks/product-tasks',
  ComponentTasksTab = '/tasks/component-tasks',
  CertificateTasksTab = '/tasks/certificate-tasks',
  AnswerPcf = '/answer-pcf/:requestId',
  PcfCompleted = '/pcf-completed',
  DigitalServiceAct = '/digital-service-act',
  MyCertificatesTab = '/certificates/my-certificates',
  SupplierCertificatesTab = '/certificates/supplier-certificates',
  SupplierCertificateDetails = '/certificates/supplier-certificates/:certificateId',
  MyCertificateDetails = '/certificates/my-certificates/:certificateId',
  MyCertificateDetailsTab = '/certificates/my-certificates/:certificateId/details',
  MyCertificatePermissionsTab = '/certificates/my-certificates/:certificateId/permissions',
  CcmTrial = '/ccm-trial',
}
